import { camelizeKeys } from 'humps';

import api from '../../lib/api';

export default async function deleteOrder(orderId: string, invoiceId: string) {
  try {
    const { data } = await api.deleteWithoutToken(
      `payments/invoices/${invoiceId}/lineitems/${orderId}`
    );
    return camelizeKeys(data);
  } catch (err) {
    throw err;
  }
}



// WEBPACK FOOTER //
// ./src/services/cart/deleteOrder.js